module.exports = "<p>\n  activity-list works!\n</p>\n"